export default __webpack_public_path__ + "static/media/ellipsis-v-solid.d529b620.svg";